import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchAllMembershipChangeList,
  handleMembershipRequest,
  throwError,
  throwSuccess,
} from "store/slices";
import { getDataFromLocalStorage, objectToFormData } from "utils/helpers";
import ProfileDetail from "./ProfileDetail";
import Card from "components/Layout/Card";
import Table from "components/Layout/Table";
import moment from "moment";
import Button from "components/form/Button";

const PendingMembershipRequests = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { membershipList, resourceCountryList,userDetails } = useSelector((state) => ({
    membershipList: state.global.membershipList,
    resourceCountryList: state.global.resourceCountryList,
    userDetails: state.student.userDetails,
  }));
  const {
    // view: viewAccess,
    update: updateAccess,
    // delete: deleteAccess,
    // create: createAccess,
  } = userDetails?.role_data?.find(
    (item) => item?.permission_name === "Profile Management"
  )?.sub_permission || {};
  const [isDeatils, setDeatils] = useState(false);
  const [userDetail, setUserDetail] = useState(null);
  const [tableList, setTableList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestLoadingType, setRequestLoadingType] = useState(false);
  const [searchPayload, setSearchPayload] = useState({
    name: "",
    membership_id_or_type: "",
    email: "",
    phoneno: "",
    join_date: "",
    valid_date: "",
    country: "",
    profile_completion: "",
    resource_name: "",
    updated_membership: "",
    type: "membership",
  });
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: 20,
  });

  const userType = getDataFromLocalStorage("user_type");

  const getProfiles = async (obj) => {
    let forData = "";
    let modifiedObj = { ...obj };
    if (
      obj?.join_date !== "custom" &&
      obj?.valid_date !== "custom" &&
      obj?.start_date &&
      obj?.end_date
    ) {
      delete modifiedObj.start_date;
      delete modifiedObj.end_date;
      forData = objectToFormData(modifiedObj);
    } else {
      forData = objectToFormData(obj);
    }

    const response = await dispatch(fetchAllMembershipChangeList(forData));
    let resList = [];
    let resResultCount = 0;
    if (response?.data?.admin_requests) {
      resList = response?.data?.admin_requests || [];
      resResultCount = response?.data?.result_count || 0;
    }
    setTableList(resList);
    setFilterData({
      ...obj,
      total: resResultCount,
    });

    window.scrollTo(0, 0);
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getProfiles(newData);
  };

   const handelRequest = async (payload) => {
      setRequestLoadingType(payload?.action_type === "1" ? "approve" : "ignore");
      setRequestLoading(payload?.id);
      const response = await dispatch(handleMembershipRequest(objectToFormData(payload)));
      if (response?.status === 200) {
        dispatch(throwSuccess(response?.message));
        getProfiles({ ...filterData, ...searchPayload });
      } else {
        dispatch(throwError(response));
      }
      setRequestLoading(false);
      setRequestLoadingType(false);
    };

  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getProfiles(newData);
  };

  useEffect(() => {
    if (["0","1", "6"].includes(userType)) {
      let updatedFilterData = { ...filterData, ...searchPayload };
      getProfiles({ ...updatedFilterData });
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPayload]);

  const header = [
    {
      isSearch: false,
      searchInputName: "name",
      title: "S.No",
    },
    {
      isSearch: true,
      searchInputName: "name",
      title: "Name",
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: {
        options: [
          { value: "Above 80%", name: "Above 80" },
          { value: "50 - 79%", name: "50 - 79" },
          { value: "Below 50%", name: "Below 50" },
        ],
        key: "name",
        value: "value",
      },
      searchInputName: "profile_completion",
      title: <div className="text-nowrap">Profile Completion</div>,
    },
    {
      isSearch: true,
      isSearchDropdown: true,
      dropdownOptions: {
        options: membershipList,
        key: "name",
        value: "name",
      },
      searchInputName: "membership_id_or_type",
      title: (
        <>
          <div>{"Membership ID"}</div>
          <div>{"& Type"}</div>
        </>
      ),
    },
    {
      isSearch: true,
      searchInputName: "email",
      title: "Email ID",
    },
    {
      isSearch: true,
      searchInputName: "phoneno",
      title: "Phone Number",
    },
    {
      isSearch: true,
      isResourceCountryFilter: ["0", "1"].includes(userType) ? false : true,
      handleApplyClick: (e) => {
        setSearchPayload((prev) => {
          return {
            ...prev,
            multiple_countries: e,
          };
        });
      },
      dropdownOptions: {
        options: resourceCountryList,
        key: "id",
        value: "country",
      },
      searchInputName: "country",
      title: <div className="text-nowrap">Country</div>,
    },
    {
      isSearch: true,
      isDatePicker: true,
      searchInputName: "join_date",
      title: "Join Date",
      isProfileManagement: true,
    },
    {
      isSearch: true,
      isDatePicker: true,
      searchInputName: "valid_date",
      title: "Valid Till",
      isProfileManagement: true,
    },
    {
      isSearch: true,
      searchInputName: "updated_membership",
      title: "Updated Type",
    },
    {
      isSearch: true,
      searchInputName: "resource_name",
      title: "Resource",
    },
    {
      isSearch: false,
      title: "Comments",
    },
    {
      isSearch: false,
      searchLable: "Approve/Ignore",
      title: "Action",
    },
  ];

  const rowData = [];
  tableList?.forEach((elem, index) => {
    const {
      id,
      user_id,
      email,
      phone,
      memberId,
      memberType,
      join_date,
      valid_till,
      firstName,
      lastName,
      country,
      profile_completion,
      updated_type,
      resource,
    } = elem;

    let isExpired = valid_till && moment().diff(valid_till, "days") > 0;
    let obj = [
      {
        value: <span>{filterData?.offset + index + 1}</span>,
      },
      {
        value: (
          <span
            className="color-new-car pointer text-nowrap"
            onClick={() => {
              setDeatils(true);
              setUserDetail(user_id);
            }}
          >
            {`${firstName} ${lastName}`}
          </span>
        ),
      },
      {
        value: (
          <span>
            {profile_completion
              ? profile_completion === "0"
                ? "0"
                : `${profile_completion}%`
              : ""}
          </span>
        ),
      },
      {
        value: (
          <span>
            {memberId && <div>{memberId}</div>}
            <div>{memberType}</div>
          </span>
        ),
      },
      {
        value: (
          <div
            style={{
              width: "250px",
              wordBreak: "break-word",
            }}
          >
            {email}
          </div>
        ),
      },
      {
        value: phone,
      },
      {
        value: country || "",
      },
      {
        value: moment(join_date).format("DD.MM.YYYY"),
      },
      {
        value: isExpired
          ? "Expired"
          : valid_till
          ? moment(valid_till).format("DD.MM.YYYY")
          : "-",
      },
      {
        value: <span className="text-nowrap">{updated_type}</span>,
      },
      {
        value: <span className=" text-nowrap">{resource}</span>,
      },
      {
        value: <span className=" text-nowrap">-</span>,
      },
      {
        value: (
          <span className="action-icon-buttons">
           {updateAccess === "1" &&  <>
              <Button
                text={"Approve"}
                btnStyle="primary-dark"
                className="mw-70 me-2 text-14-400"
                onClick={() => {
                  handelRequest({ action_type: "1", user_id: user_id,id:id });
                }}
                isSquare
                btnLoading={
                  requestLoadingType === "approve" && requestLoading === id
                }
              />
              <Button
                text={"Ignore"}
                className="mw-70 me-2 text-14-400"
                btnStyle="danger-outline"
                onClick={() => {
                  handelRequest({ action_type: "2", user_id: user_id,id:id});
                }}
                isSquare
                btnLoading={
                  requestLoadingType === "ignore" && requestLoading === id
                }
              />
            </>}
          </span>
        ),
      },
    ];
    rowData.push({ data: obj });
  });
  return (
    <>
      {isDeatils && (
        <ProfileDetail
          userID={userDetail}
          onHide={() => {
            setDeatils(false);
          }}
        />
      )}

      <Card className="cps-20 cpe-20 cpb-20">
        <div
          className={`cmb-20 d-flex justify-content-between align-items-center flex-wrap cpt-28`}
        >
          <div className="table-title">
            {`Membership Type Changes`} ({filterData?.total})
          </div>
        </div>

        <div className="w-100">
          <Table
            isLoading={isLoading}
            header={header}
            rowData={rowData}
            filterData={filterData}
            searchPayload={searchPayload}
            searchInputChange={handelChangeSearch}
            changeOffset={handelChangePagination}
            isOtherPagination
            maxHeight="60vh"
          />
        </div>
      </Card>
    </>
  );
};

export default PendingMembershipRequests;
